<div class="width-100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title' (click)="goBack()" style="cursor: pointer;">
        <mat-icon>arrow_back</mat-icon>
        <div>{{annuity_name}}</div>
      </div>

      <div flex justify-content='flex-end' fxLayoutAlign="end">
        <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
          autocomplete="off">
      </div>

      <a mat-button (click)="exportCSV()" style='width:60px;' *ngIf="payedDataSource">
        <mat-icon color='primary'>download</mat-icon>
      </a>

      <button mat-button style='width:60px;' (click)="openPayDialog(null)">
        <mat-icon class='icon-add'>add_circle_outline</mat-icon>
      </button>

    </mat-toolbar>

    <mat-tab-group>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon' style="color: green;">monetization_on</mat-icon>
          <div>Pago</div>
        </ng-template>

        <mat-card>
          <span style="color:rgba(0,0,0, .6)">
            <b>R$ {{totalOrdered | currency:'BRL':'':'1.2-2' }} - {{countOrdered}} itens</b>
          </span>
        </mat-card>

        <mat-table [dataSource]="payedDataSource" matSort>

          <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Data </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div style="display: flex; flex-direction: column; padding: 10px 0 10px 0;">
                <div *ngIf='element.date'>
                  {{ element.date.seconds*1000 | date: 'dd/MM/yyyy' }}
                </div>
                <div *ngIf='element.payDate'>
                  {{ element.payDate | date: 'dd/MM/yyyy' }}
                </div>
              </div>
            </mat-cell>
            <mat-cell mat-footer-cell *matFooterCellDef></mat-cell>
          </ng-container>

          <ng-container matColumnDef="member_name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div style="display: flex; flex-direction: column; padding: 10px 0 10px 0;">
                <div>
                  {{ element.member_name }}
                </div>
                <div>
                  <i>{{ element.category_name }}</i>
                </div>
              </div>
            </mat-cell>
            <mat-cell mat-footer-cell *matFooterCellDef> </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Tid">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Transação </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.Tid }}
              <br>
              {{ element.type }} - {{ element.origin }}
            </mat-cell>
            <mat-cell mat-footer-cell *matFooterCellDef> </mat-cell>
          </ng-container>

          <ng-container matColumnDef="installments">
            <mat-header-cell *matHeaderCellDef mat-sort-header> X </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span *ngIf="element.installments">{{element.installments}}</span>
              <span *ngIf="element.card_installments">{{element.card_installments}}</span>
            </mat-cell>
            <mat-cell mat-footer-cell *matFooterCellDef> </mat-cell>
          </ng-container>

          <ng-container matColumnDef="discount">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Desc/Deb </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div style="display: flex; flex-direction: column; padding: 10px 0 10px 0;">
                <div>{{ element.discount | currency:'BRL':'':'1.2-2' }}</div>

                <!--  <div *ngIf="!element.discounnt">0</div> -->

                <div *ngIf="element.member_debit">{{element.member_debit | currency:'BRL':'':'1.2-2' }}</div>
                <div *ngIf="!element.member_debit">0</div>
              </div>
            </mat-cell>
            <mat-cell mat-footer-cell *matFooterCellDef> </mat-cell>
          </ng-container>

          <ng-container matColumnDef="original">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Original </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span *ngIf="element.api != 'asaas'">0</span>
              <span *ngIf="element.api == 'asaas'">{{ element.rawValue | currency:'BRL':'':'1.2-2' }}</span>
            </mat-cell>
            <mat-cell mat-footer-cell *matFooterCellDef> </mat-cell>
          </ng-container>

          <ng-container matColumnDef="value">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Valor </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span>{{ element.value | currency:'BRL':'':'1.2-2' }}</span>
            </mat-cell>
            <mat-cell mat-footer-cell *matFooterCellDef> </mat-cell>
          </ng-container>

          <ng-container matColumnDef="total">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Total </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span>{{ element.total | currency:'BRL':'':'1.2-2' }}</span>
            </mat-cell>
            <mat-cell mat-footer-cell *matFooterCellDef></mat-cell>
          </ng-container>

          <ng-container matColumnDef="tax">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Taxa </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span *ngIf="element.tax">{{element.tax}}</span>
              <span *ngIf="!element.tax">0</span>
            </mat-cell>
            <mat-cell mat-footer-cell *matFooterCellDef></mat-cell>
          </ng-container>

          <ng-container matColumnDef="total_minus_tax">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Liquido </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span>{{ element.total_minus_tax | currency:'BRL':'':'1.2-2' }}</span>
            </mat-cell>
            <mat-cell mat-footer-cell *matFooterCellDef>
              <b>
                {{countOrdered}}
                <br>
                {{totalOrdered | currency:'BRL':'':'1.2-2' }} </b>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openViewerDialog(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-info' style='font-size:1.5em;'>
                  info_outline
                </mat-icon>
              </a>
            </mat-cell>
            <mat-cell mat-footer-cell *matFooterCellDef> </mat-cell>
          </ng-container>

          <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openDeleteDialog(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-delete' style='font-size:1.5em;'>
                  delete_outline
                </mat-icon>
              </a>
            </mat-cell>
            <mat-cell mat-footer-cell *matFooterCellDef> </mat-cell>
          </ng-container>

          <!--          
            <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openDeleteDialog(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>
-->

          <mat-header-row *matHeaderRowDef="displayedPayedColumns"></mat-header-row>

          <mat-row *matRowDef="let row; columns: displayedPayedColumns;"></mat-row>

          <mat-row mat-footer-row *matFooterRowDef="displayedPayedColumns; sticky: true"></mat-row>

        </mat-table>

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon' style="color: red;">monetization_on</mat-icon>
          <div>Pendentes</div>
        </ng-template>

        <mat-card>
          <span style="color:rgba(0,0,0, .6)">
            <b>R$ {{totalNotPayed | currency:'BRL':'':'1.2-2' }} - {{countNotPayed}} itens</b>
          </span>
        </mat-card>

        <!-- TABLE -->
        <mat-table [dataSource]="notPayedDataSource" matSort>

          <!-- Icon Column -->
          <ng-container matColumnDef="icon">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon style='font-size:1.2em; margin-top:10px;'>dashboard_customize</mat-icon>
            </mat-cell>
            <mat-cell mat-footer-cell *matFooterCellDef></mat-cell>
          </ng-container>

          <!-- name Column -->
          <ng-container matColumnDef="member">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.name }}
            </mat-cell>
            <mat-cell mat-footer-cell *matFooterCellDef> </mat-cell>
          </ng-container>

          <!-- subcategpory Column -->
          <ng-container matColumnDef="subCategory_name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Category </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.subCategory_name }}
            </mat-cell>
            <mat-cell mat-footer-cell *matFooterCellDef> </mat-cell>
          </ng-container>


          <!-- subcategpory Column -->
          <ng-container matColumnDef="annuity_from">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Vigência </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.annuity_from }}
            </mat-cell>
            <mat-cell mat-footer-cell *matFooterCellDef> </mat-cell>
          </ng-container>

          <ng-container matColumnDef="value">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Valor </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.value | currency:'BRL':'':'1.2-2' }}
            </mat-cell>
            <mat-cell mat-footer-cell *matFooterCellDef>
              <b>
                {{countNotPayed}}
                <br>
                {{totalNotPayed | currency:'BRL':'':'1.2-2' }}
              </b>
            </mat-cell>
          </ng-container>

          <!-- edit Column -->
          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openViewerDialog(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-info' style='font-size:1.5em;'>
                  info_outline
                </mat-icon>
              </a>
            </mat-cell>
            <mat-cell mat-footer-cell *matFooterCellDef> </mat-cell>
          </ng-container>

          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayedNotPayedColumns"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedNotPayedColumns;"></mat-row>

          <!-- Footer -->
          <mat-row mat-footer-row *matFooterRowDef="displayedNotPayedColumns; sticky: true"></mat-row>

        </mat-table>
        <!-- END TABLE -->

      </mat-tab>

    </mat-tab-group>



  </mat-card>

</div>